import { render, staticRenderFns } from "./勘定科目大分類Select.vue?vue&type=template&id=f2c05350&"
import script from "./勘定科目大分類Select.ts?vue&type=script&lang=ts&"
export * from "./勘定科目大分類Select.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports